module.exports = "/_next/static/images/external_link-604a52e1fdb82aaae93fc22c5c235618.svg";